import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_PRODUCTION_PLAN',
    url: '',
    method: 'GET',
  });

  const fetchData = function () {
    let url = `/api/production-plans`;
    if (params) {
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
    }
    exec(url);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [data || [], fetchData, isRequestSuccessed];
});
